import React from "react"
import Footer from "@components/Footer"
import { useIntl } from "@components/Intl"
import { Box, Container } from "@components/Layout"
import SEO from "@components/SEO"
import { Paragraph, TitleXL } from "@components/Typography"
import ProductGrid from "./ProductGrid"
import { ArrowLink } from "@components/ArrowLink"
import { CollectionDetailPage } from "@lib/kontent/models-deprecated/collection_detail_page"
import { ChoicesThemeProfileCodeFilter } from "@generated"

interface Props {
  collection: CollectionDetailPage
  themeProfile: ChoicesThemeProfileCodeFilter
}

const ThemeprofileCollection: React.FC<Props> = ({
  collection,
  themeProfile,
}) => {
  const { messages } = useIntl()
  return (
    <>
      <SEO
        title={collection.seoMetaTitle.value}
        description={collection.seoMetaDescription.value}
        imageUrl={collection.seoMetaImage.value[0]?.url}
        urlKey={"new-collection"}
      />
      <Container mt={["5rem", "5rem", "6rem"]} py={["4rem", "3rem"]}>
        <Box display={["none", "block"]}>
          <ArrowLink
            variant="arrow-left"
            href={messages.navigation.collection.url}
            as={messages.navigation.collection.url}
          >
            {messages.navigation.collection.title}
          </ArrowLink>
        </Box>

        <Box maxWidth={"30rem"} py={4}>
          <TitleXL>{collection.title.value}</TitleXL>
          <Paragraph>{collection.description.value}</Paragraph>
        </Box>

        <ProductGrid
          themeProfile={themeProfile}
          firstTitle={collection.firstCardTitle.value}
          firstText={collection.firstCardText.value}
          secondTitle={collection.secondCardTitle.value}
          secondText={collection.secondCardText.value}
        />
      </Container>
      <Footer />
    </>
  )
}

export default ThemeprofileCollection
